import Box from '@/common/components/Box'
import { ShowHeader } from '@/common/components/ShowHeader'
import Skeleton from '@/common/components/Skeleton'

const PaymentAdvanceCreateLoadingState = () => {
  return (
    <div>
      <ShowHeader goBack backTo="/payment-advances" title={<Skeleton width={240} height={32} />} />

      <Box className="max-h-[calc((100vh-104px-1.5rem))] overflow-y-auto space-y-6">
        <div className="space-y-4">
          <div className="space-y-1">
            <Skeleton width={400} height={16} />
            <Skeleton width={300} height={16} />
          </div>

          <div className="space-y-2">
            <Skeleton width={160} height={24} />

            <div className="flex gap-4">
              <div className='space-y-1'>
                <Skeleton width={80} height={18} />
                <Skeleton width={240} height={24} />
              </div>

              <div className='space-y-1'>
                <Skeleton width={120} height={18} />
                <Skeleton width={140} height={24} />
              </div>

              <div className='space-y-1'>
                <Skeleton width={120} height={18} />
                <Skeleton width={140} height={24} />
              </div>

              <div className='space-y-1'>
                <Skeleton width={160} height={18} />
                <Skeleton width={140} height={24} />
              </div>
            </div>
          </div>

          <div className="flex gap-2">
            <div className='space-y-1 w-full'>
              <Skeleton width={160} height={18} />
              <Skeleton height={52} className='bg-white-100 rounded-md' />
            </div>

            <div className='space-y-1 w-full'>
              <Skeleton width={160} height={18} />
              <Skeleton height={52} className='bg-white-100 rounded-md' />
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <Skeleton width={140} height={24} />

          <div className="space-y-1">
            <Skeleton width={400} height={16} />
            <Skeleton width={200} height={16} />
          </div>

          <div className="grid grid-cols-3 gap-4">
            <div className="flex flex-col gap-1 bg-white-100 p-3 rounded-lg">
              <Skeleton width={120} height={16} />
              <Skeleton width={150} height={20} />
            </div>

            <div className="flex flex-col gap-1 bg-white-100 p-3 rounded-lg">
              <Skeleton width={120} height={16} />
              <Skeleton width={150} height={20} />
            </div>

            <div className="flex flex-col gap-1 bg-white-100 p-3 rounded-lg">
              <Skeleton width={120} height={16} />
              <Skeleton width={150} height={20} />
            </div>
          </div>
        </div>

        <div className="w-full h-px bg-white-300" />

        <div className="grid grid-cols-2 gap-4 items-start">
          <div className="flex flex-col gap-1 bg-white-100 p-3 rounded-lg">
            <Skeleton width={120} height={16} />
            <Skeleton width={150} height={20} />
          </div>

          <div className="flex flex-col gap-1 bg-white-100 p-3 rounded-lg">
            <Skeleton width={120} height={16} />
            <Skeleton width={150} height={20} />
          </div>
        </div>

        <div className="flex gap-4 items-end">
          <div className="grid w-full grid-cols-2 gap-4">
            <div className="flex flex-col gap-1 bg-white-100 p-3 rounded-lg">
              <Skeleton width={120} height={16} />
              <Skeleton width={150} height={20} />
            </div>

            <div className="flex flex-col gap-1 bg-white-100 p-3 rounded-lg">
              <Skeleton width={120} height={16} />
              <Skeleton width={150} height={20} />
            </div>
          </div>

          <Skeleton width={270} height={40} className='bg-white-100' />
        </div>
      </Box>
    </div>
  )
}

export default PaymentAdvanceCreateLoadingState
